import React, { FC, Fragment, useState } from 'react';
import { useQuery } from '@apollo/client';
import { fortnoxStatusTemplate } from 'apollo/templates/fortnox';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { fortnoxStatusVar } from 'apollo/reactive-variables/invoice';
import { Alert, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';

const FortnoxAuthContainer: FC = () => {
    const { t: translate } = useTranslation(['common', 'invoices']);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [fortnoxAuthUrl, setFortnoxAuthUrl] = useState('');
    const fortnoxFrontendStatus = fortnoxStatusVar();
    const { showBoundary } = useDenthubErrorBoundary();
    const isCurrentlyAuthorizing = window.location.href.includes('fortnox-auth-callback');

    useQuery(fortnoxStatusTemplate, {
        onCompleted: ({ fortnoxStatus }) => {
            fortnoxStatusVar(fortnoxStatus);
            if (fortnoxStatus.enabled && !fortnoxStatus.authorized && !isCurrentlyAuthorizing) {
                const state = new Date().getTime().toString();
                localStorage.setItem(CONSTANTS.FORTNOX_TEMP_STATE_KEY, state);
                setDialogOpen(true);
                setFortnoxAuthUrl(
                    `${CONSTANTS.FORTNOX_AUTH_URL}?client_id=${fortnoxStatus.clientId}&redirect_uri=${encodeURIComponent(CONSTANTS.FORTNOX_REDIRECT_URL)}&state=${state}&scope=archive connectfile invoice customer companyinformation&access_type=offline&response_type=code`,
                );
            }
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const onDialogClose = () => {
        setDialogOpen(false);
    };

    return (
        <Fragment>
            {fortnoxFrontendStatus.enabled ? (
                <DHDialog
                    fullWidth
                    maxWidth="sm"
                    open={dialogOpen}
                    onClose={onDialogClose}
                    title={translate('invoices:YOU_NEED_TO_LOGIN_TO_FORTNOX')}
                >
                    <Alert severity="info" sx={{ whiteSpace: 'pre-wrap' }}>
                        {translate('invoices:FORTNOX_LOGIN_DESC')}
                    </Alert>
                    <Box mt={2} sx={{ textAlign: 'center' }}>
                        <Button variant="contained" href={fortnoxAuthUrl}>
                            {translate('invoices:LOGIN_TO_FORTNOX')}
                        </Button>
                    </Box>
                </DHDialog>
            ) : undefined}
        </Fragment>
    );
};

export default FortnoxAuthContainer;
